import api from './api';
import { toast } from 'react-toastify';

export function findAllMedicamentosByMedicoAndReceita(farmaciaId, medicoId, receitaId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/usuarios/${medicoId}/receitas/${receitaId}/medicamentos`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Erro ao buscar os medicamentos da receita");
      return reject(e);
    }
  });
}
